import { render, staticRenderFns } from "./RouterSummaryGeneral.vue?vue&type=template&id=458c53a4"
import script from "./RouterSummaryGeneral.vue?vue&type=script&lang=ts"
export * from "./RouterSummaryGeneral.vue?vue&type=script&lang=ts"
import style0 from "./RouterSummaryGeneral.vue?vue&type=style&index=0&id=458c53a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports